import React from 'react';

export const OverlayEndImmersifContext = React.createContext({
  show: false,
  setShow: (forced: boolean) => {}
});

export default OverlayEndImmersifContext;